import { ref } from "vue";

const CarModelOptions = ref([
  {
    value: "SC50",
    label: "SC50",
  },
  {
    value: "SC80",
    label: "SC80",
  },
]);
const isEnableOptions = ref([
  {
    value: true,
    label: "启用",
  },
  {
    value: false,
    label: "禁用",
  },
]);

const WorkingModeOptions = ref([
  {
    value: 0,
    label: "全补给",
  },
  {
    value: 1,
    label: "仅充电",
  },
]);
export { CarModelOptions, isEnableOptions, WorkingModeOptions };
